/**
 * Requests the device's microphone for one voice note, the way
 * `useCamera` requests its video stream for a live viewfinder. A dead
 * button teaches nothing, so a browser with no `getUserMedia` and a denied
 * permission prompt answer with two different, actionable messages rather
 * than one generic failure.
 */
export async function requestMicrophoneStream(): Promise<MediaStream> {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error('Microphone access is unavailable on this device or browser.');
  }
  try {
    return await navigator.mediaDevices.getUserMedia({ audio: true });
  } catch {
    throw new Error('Microphone access was blocked. Allow it in this browser to record a voice note.');
  }
}

/** Stops every track of a microphone stream, so the browser's recording
 *  indicator clears once a clip is done. */
export function releaseMicrophoneStream(stream: MediaStream): void {
  for (const track of stream.getTracks()) track.stop();
}
